import {createStore} from 'zustand/vanilla';
import type {User} from '../types/user';

export interface UserState {
  user: User | null;
}

export const defaultInitState: UserState = {
  user: null,
};

export interface UserActions {
  setUser: (user: User | null) => void;
  getUser: () => User | null;
}

export type UserStore = UserState & UserActions;

export const createUserStore = (initState: UserState = defaultInitState) =>
  createStore<UserStore>((set, get) => ({
    ...initState,
    setUser: user => set({user}),
    getUser: () => get().user,
  }));
